export const PRODUCT_COLLECTION = [
  {
    slug: "porcelain",
    name: "Porcelain Tiles",
    tagline: "Dense. Durable. Effortlessly modern.",
    description:
      "Engineered for both interior and exterior installations, our porcelain collection delivers low porosity, exceptional resilience, and a vast spectrum of finishes — from honed concrete looks to book-matched veining.",
    specs: ["Indoor & outdoor", "Slip-resistant options", "Large format up to 60×120 in."],
    image:
      "https://images.pexels.com/photos/11285340/pexels-photo-11285340.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "ceramic",
    name: "Ceramic Tiles",
    tagline: "Crafted character for everyday surfaces.",
    description:
      "A versatile foundation for kitchens, baths, and feature walls. Hand-finished glazes, terracotta warmth, and zellige-inspired textures bring depth without compromise.",
    specs: ["Glazed & unglazed", "Hand-finished options", "Suited to walls & light floors"],
    image: "/ceramic.png",
  },
  {
    slug: "marble",
    name: "Marble",
    tagline: "The original luxury, quarried and curated.",
    description:
      "Calacatta, Statuario, Crema Marfil, Nero Marquina. Each slab is hand-selected for movement, clarity, and consistency — the heart of any heirloom interior.",
    specs: ["Honed, polished & leather finishes", "Slabs & cut-to-size", "Sealed for South Florida humidity"],
    image: "/marble.png",
  },
  {
    slug: "pavers",
    name: "Pavers",
    tagline: "Architecture for the outdoors.",
    description:
      "From pool decks to motor courts, our pavers are engineered for the coastal climate. Natural stone, porcelain, and travertine pavers in formats designed for seamless transitions.",
    specs: ["UV-stable color", "Salt & chlorine resistant", "ICPI-compliant formats"],
    image: "/pavers.png",
  },
  {
    slug: "travertine",
    name: "Travertine",
    tagline: "Quiet warmth. Timeless texture.",
    description:
      "Quarried travertine in ivory, walnut, and silver tones. Honed-and-filled or brushed finishes — engineered to age beautifully through Florida summers.",
    specs: ["French pattern & plank formats", "Vein cut & cross cut", "Pool-coping & step treads"],
    image:
      "https://images.pexels.com/photos/4709033/pexels-photo-4709033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const REVIEWS_DATA = [
  {
    name: "Marcus T.",
    role: "Warehouse Associate",
    tenure: "2 years",
    rating: 5,
    title: "Genuinely good people to work with.",
    quote:
      "Management actually listens. The team is tight, the work is hands-on, and you can see the pride people take in the product. Coming in every day feels purposeful.",
    source: "Indeed",
  },
  {
    name: "Diana R.",
    role: "Showroom Specialist",
    tenure: "1 year",
    rating: 5,
    title: "Beautiful product, supportive leadership.",
    quote:
      "I get to spend my day around incredible materials and talk design with clients who care. Training was thorough, and growth opportunities are real.",
    source: "Glassdoor",
  },
  {
    name: "Hector V.",
    role: "Delivery Driver",
    tenure: "3 years",
    rating: 4,
    title: "Fair pay, well-maintained trucks, great routes.",
    quote:
      "Routes are planned thoughtfully, the trucks are kept in great shape, and dispatch communicates clearly. South Florida traffic aside, it’s a solid place to drive for.",
    source: "Indeed",
  },
  {
    name: "Priya S.",
    role: "Operations Coordinator",
    tenure: "4 years",
    rating: 5,
    title: "A craft-first culture in a logistics business.",
    quote:
      "It’s rare to find a company where ops, sales, and warehouse all respect each other’s craft. That balance is what keeps me here.",
    source: "Glassdoor",
  },
];

export const TRUST_LOGOS = [
  "Coastal Living Developments",
  "Atlantic Designers Guild",
  "Miami Architectural Review",
  "Palm Beach Builders Assoc.",
  "South Florida Interiors",
  "Boca Construction Council",
];
